// ErrorBoundary.jsx
import React, { Component } from "react";

export class ErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="alert alert-danger">
          Errore nel grafico. <button onClick={() => this.setState({ hasError: false })}>Riprova</button>
        </div>
      );
    }
    return this.props.children;
  }
}